/* global System */

import { djedi } from 'djedi-react'
import { Map } from 'immutable'
import { createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'

import { djediNodesSelector } from 'views/App/selectors'

import reducer, { addReducer } from './reducers'
import configureMiddleware from './middleware'
import configureRoutes from './routes'

export default async (history, initialState = new Map()) => {
  const {
    reducer: routeReducer,
    middleware: routeMiddleware,
    enhancer: routeEnhancer,
    thunk,
  } = configureRoutes(history)

  addReducer('location', routeReducer)

  const store = createStore(
    reducer,
    initialState,
    composeWithDevTools(routeEnhancer, configureMiddleware([routeMiddleware])),
  )

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      System.import('./reducers').then(reducerModule => {
        store.replaceReducer(reducerModule.default)
      })
    })
  }

  const nodes = djediNodesSelector(store.getState())
  djedi.addNodes(nodes)

  await thunk(store)

  return store
}



// WEBPACK FOOTER //
// ../source/state/store.js